import "@pmo/ui/fonts";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { createI18n } from "@pmo/i18n";
import { AppProviders } from "@pmo/shell";
import { ConfirmProvider } from "@pmo/ui";
import { router } from "./app/router";
import en from "./locales/en";
import ar from "./locales/ar";

const i18n = createI18n({ resources: { en: { console: en }, ar: { console: ar } }, defaultNS: "console" });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProviders i18n={i18n}>
      <ConfirmProvider>
        <RouterProvider router={router} />
      </ConfirmProvider>
    </AppProviders>
  </StrictMode>,
);
